import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PostAPI, PutAPI } from '../ultilies/API';
import '../css/commonForm.css';

function CategoryForm() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const isEdit = !!state;

    const [formData, setFormData] = useState({
        name: state?.name || '',
        shortTitle: state?.shortTitle || '',
        categoryIcon: state?.categoryIcon || null,
        categoryBanner: state?.categoryBanner || null
    });

    const [previews, setPreviews] = useState({
        icon: state?.categoryIcon || null,
        banner: state?.categoryBanner || null
    });

    const handleFile = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            setPreviews({ ...previews, [field]: URL.createObjectURL(file) });
            setFormData({ ...formData, [field === 'icon' ? 'categoryIcon' : 'categoryBanner']: file });
        }
    };

    const handleSave = () => {
        const api = isEdit ? PutAPI : PostAPI;
        const url = isEdit ? `/cms/categories/${state._id}` : `/cms/categories`;
        api(url, formData, () => navigate('/gamecategories'));
    };

    return (
        <div className="cat-form-container">
            {/* <div className="preview-side">
                <div className="cat-card-preview">
                    <div className="cat-banner-box">
                        {previews.banner && <img src={previews.banner} alt="Banner" />}
                    </div>
                    <div className="cat-icon-box">
                        {previews.icon && <img src={previews.icon} alt="Icon" />}
                    </div>
                    <h4>{formData.name || "Category Name"}</h4>
                    <p>{formData.shortTitle || "Description summary..."}</p>
                </div>
            </div> */}

            <div className="fields-side">
                <h2>{isEdit ? 'Edit Category' : 'Create Category'}</h2>
                
                <label>Category Name</label>
                <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="e.g. Custom Games" />

                <label>Short Title (Description)</label>
                <textarea value={formData.shortTitle} onChange={e => setFormData({...formData, shortTitle: e.target.value})} placeholder="Describe this category..." />

                <div className="upload-group">
                    <label>Category Icon (SVG/PNG)</label>
                    <input type="file" onChange={e => handleFile(e, 'icon')} />
                </div>

                <div className="upload-group">
                    <label>Category Banner (.webp)</label>
                    <input type="file" accept=".webp" onChange={e => handleFile(e, 'banner')} />
                </div>

                <button className="save-btn" onClick={handleSave}>Save Category</button>
            </div>
        </div>
    );
}

export default CategoryForm;